// Side-effect requests that don't need to update Inertia page state. Using router.patch on
// a 204 response makes Inertia render the empty body in a full-screen error iframe
// ("non-Inertia response"). Plain fetch sidesteps that pipeline.

import { resetClientState } from "@/lib/resetClientState";
import { csrfToken } from "@/lib/csrf";

export { csrfToken };

export async function patchSideEffect(url: string, body: unknown): Promise<Response> {
  return fetch(url, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-CSRF-Token": csrfToken(),
    },
    credentials: "same-origin",
    body: JSON.stringify(body),
  });
}

// Session expiry is the other path off the app besides the sign-out button — without
// this the previous user's task titles/notes stay in IndexedDB. Awaited: assign() unloads
// the document, and a purge racing the navigation is not guaranteed to finish.
export async function redirectToSignIn(): Promise<void> {
  await resetClientState();
  window.location.assign("/users/sign_in");
}
